import Page from "webPage/Page";
import GravityForm from "util/GravityForm.js";
import RecaptchaHelper from "util/RecaptchaHelper.js";

Page.register('page-template-tpl-contact', () => {
    let $forms = $('.js-gravity-form');
    let forms = [];

    RecaptchaHelper.load().then(() => {
        $forms.each(function (index) {
            let form = new GravityForm($(this));
            forms[form.formid] = form;
        });
    });

    $('[data-form-toggle]').click(function () {
        let form = $(this).attr('data-form-toggle');

        $('[data-form]').removeClass('block').addClass('hidden');
        $('[data-form="' + form + '"]').removeClass('hidden').addClass('block');

        forms[form].show();

        if ($(window).width() < 1024) {
            $('html, body').animate({
                scrollTop: ($('#contact-form').offset().top),
            }, 500);
        }
    });
});
